"use strict";

require("core-js/modules/es6.array.sort");

var _regeneratorRuntime = require("/home/circleci/project/frontends/frontdoor/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCourthouses;

var _lodash = require("lodash");

var _axios = _interopRequireDefault(require("axios"));

var _courts = _interopRequireDefault(require("./courts"));

var _getDistanceFromLatLonInMi = _interopRequireDefault(require("../geo/getDistanceFromLatLonInMi"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
} // Takes list of courthouses and addressObj from case prop and returns courthouses sorted by distance


function sortCourthousesByDistance(_x, _x2) {
  return _sortCourthousesByDistance.apply(this, arguments);
}

function _sortCourthousesByDistance() {
  _sortCourthousesByDistance = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(unsortedCourthouses, addressObj) {
    var sortedCourthouses, addressString, httpInstance, latLon, i;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sortedCourthouses = unsortedCourthouses; // Build address string, filtering out null address fields

            addressString = [addressObj.street1, addressObj.city, addressObj.state, addressObj.country, addressObj.zipcode].filter(function (n) {
              return n;
            }).join(' ');
            _context2.prev = 2; // Use HERE geocoding API to get coordinates for address

            httpInstance = _axios["default"].create({
              baseURL: 'https://geocoder.api.here.com/6.2'
            });
            _context2.next = 6;
            return new Promise(
            /*#__PURE__*/
            function () {
              var _ref = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(res, rej) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return httpInstance.get('/geocode.json', {
                          params: {
                            app_id: process.env.HERE_API_APP_ID,
                            app_code: process.env.HERE_API_API_CODE,
                            searchtext: addressString
                          }
                        }).then(function (response) {
                          var lat = (0, _lodash.get)(response, 'data.Response.View[0].Result[0].Location.DisplayPosition.Latitude');
                          var lon = (0, _lodash.get)(response, 'data.Response.View[0].Result[0].Location.DisplayPosition.Longitude');

                          if (lat !== undefined && lon !== undefined) {
                            res({
                              latitude: lat,
                              longitude: lon
                            });
                          } else {
                            throw new Error('latitude or longitude not found.');
                          }
                        });

                      case 3:
                        _context.next = 8;
                        break;

                      case 5:
                        _context.prev = 5;
                        _context.t0 = _context["catch"](0);
                        rej(_context.t0);

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 5]]);
              }));

              return function (_x5, _x6) {
                return _ref.apply(this, arguments);
              };
            }());

          case 6:
            latLon = _context2.sent; // Now get distance for each courthouse, append to object, and sort

            for (i = 0; i < sortedCourthouses.length; i += 1) {
              if (sortedCourthouses[i].coordinates == null) {
                sortedCourthouses[i].distance = null;
              } else {
                sortedCourthouses[i].distance = (0, _getDistanceFromLatLonInMi["default"])(latLon.latitude, latLon.longitude, sortedCourthouses[i].coordinates.latitude, sortedCourthouses[i].coordinates.longitude);
              }
            } // Sort by distance, ascending


            return _context2.abrupt("return", sortedCourthouses.sort(function (a, b) {
              return a.distance < b.distance ? -1 : 1;
            }));

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", unsortedCourthouses);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 11]]);
  }));
  return _sortCourthousesByDistance.apply(this, arguments);
}

function getCourthouses(_x3, _x4) {
  return _getCourthouses.apply(this, arguments);
}

function _getCourthouses() {
  _getCourthouses = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(district, address) {
    var courthouses;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            courthouses = [];

            if (!(district == null)) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", courthouses);

          case 3:
            // Set Courthouses
            if (district != null) {
              courthouses = _courts["default"].filter(function (c) {
                return c.district === district;
              });
            } // Sort courthouses if we have an address


            if (!(address != null)) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return sortCourthousesByDistance(courthouses, address);

          case 7:
            courthouses = _context3.sent;

          case 8:
            return _context3.abrupt("return", courthouses);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getCourthouses.apply(this, arguments);
}